import { render, staticRenderFns } from "./ProductPOMomentHistory.vue?vue&type=template&id=47c222d3"
import script from "./ProductPOMomentHistory.vue?vue&type=script&lang=js"
export * from "./ProductPOMomentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports